import React from "react";

const HeaderRow = () => {
    return (
        <thead>
            <tr className="header">
                <th className="width-17">Date</th>
                <th className="width-17 hover-tip">
                    Free Icon Downloads<i className="ui_help"></i>{" "}
                    <span>Public domain and attributed icons</span>
                    <div className="tooltip tooltip-top tooltip-align-left">
                        <p>
                            If someone downloads an icon with a Creative Commons
                            license, they must give artists credit instead of
                            paying.
                        </p>
                    </div>
                </th>
                <th className="width-17 hover-tip">
                    Single Icon Purchases<i className="ui_help"></i>{" "}
                    <span>
                        Earn 60% royalty
                        <br /> per purchase
                    </span>
                    <div className="tooltip tooltip-top tooltip-align-left">
                        <p>
                            An artist earns 60% of the purchase price when their
                            icon is purchased a-la-carte.
                        </p>
                    </div>
                </th>
                <th className="width-17 hover-tip">
                    Subscription Downloads<i className="ui_help"></i>{" "}
                    <span>
                        Earn 50% royalty
                        <br /> from subscriber pool
                    </span>
                    <div className="tooltip tooltip-top tooltip-align-left">
                        <p>
                            Artists earn 50% of the month’s Pro revenue after
                            expenses
                        </p>
                    </div>
                </th>
                <th className="width-17 hover-tip">
                    API
                    <br />
                    Uses<i className="ui_help"></i>{" "}
                    <span>
                        Earn 50% royalty
                        <br /> from API pool
                    </span>
                    <div className="tooltip tooltip-top tooltip-align-left">
                        <p>
                            Artists receive 50% of the month’s API revenue,
                            shared proportionally based on icon uses.
                        </p>
                    </div>
                </th>
                <th className="width-12 hover-tip">
                    Monthly Earnings
                    <div className="tooltip tooltip-top tooltip-align-left">
                        <p>
                            "Your total royalties from Single purchases, Pro,
                            and API downloads."
                        </p>
                    </div>
                </th>
                <th className="width-12 hover-tip">
                    Monthly Paid
                    <div className="tooltip tooltip-top tooltip-align-left">
                        <p>
                            "How much money has been transferred to your PayPal
                            account this month."
                        </p>
                    </div>
                </th>
            </tr>
        </thead>
    );
};

export default HeaderRow;
